/**
 * Host-side only: never import it from the byte-synced `donation-form/` renderer.
 * Return the value verbatim — never trimmed, stripped or capped: the token is opaque.
 */
export function readAttributionToken(search) {
    const raw = new URLSearchParams(search).get("at");
    return raw !== null && raw.trim() !== "" ? raw : undefined;
}
